<template>
  <div>
    <div class="CompanyprofileText">
      <div class="Text">
        公司简介
        <a href="javascript:;" class="SeeMore"></a>
      </div>
    </div>
    <div class="CompanyprofileCenter">
      <CompanyprofileLeft></CompanyprofileLeft>
      <CompanyprofileRight></CompanyprofileRight>
      <div class="Center">
        <img src="../../../../../../assets/channel/homePng/lefthome.png" alt="" style="margin-right: 5px;">
        ABOUT
        <img src="../../../../../../assets/channel/homePng/righthome.png" alt="" style="margin-left: 5px;">
      </div>
    </div>
  </div>
</template>

<script>
import CompanyprofileLeft from './CompanyprofileLeft/CompanyprofileLeft.vue'
import CompanyprofileRight from './CompanyprofileRight/CompanyprofileRight.vue'
export default {
  components: {
    CompanyprofileLeft,
    CompanyprofileRight
  },
  data() {
    return {

    }
  },
  mounted() {

  },
  methods: {

  }
}
</script>

<style lang="less">
.CompanyprofileText {
  height: 200px;
  //   border: 1px solid cornflowerblue;
  display: flex;
  justify-content: center;
  align-items: center;
  user-select: none;


  .Text {
    width: 340px;
    height: 155px;
    // border: 1px solid saddlebrown;
    color: #16181a;
    font-size: 28px;
    font-weight: bold;
    text-align: center;
    line-height: 120px;
    overflow: hidden;
    position: relative;

    .SeeMore {
      height: 50%;
      width: 100%;
      display: block;
      color: #16181a;
      font-weight: 400;
      font-size: 14px;
      text-decoration: none;
      position: absolute;
      top: -20px;
      transform: translate(0%, 65%);
    }
    .SeeMore::before {
      content: "归创通桥致力于外周和神经介入领域医疗器械    ";
      color: #424e66;
    }
  }
}
.CompanyprofileCenter {
  width: 1200px;
  height: 360px;
  margin: 0 auto;
  display: flex;
  justify-content: space-around;
  position: relative;
}
.Center {
  width: 160px;
  height: 40px;
  background-color: #00266d;
  border-radius: 2px;
  color: #ffffff;
  font-size: 16px;
  text-align: center;
  line-height: 40px;
  position: absolute;
  right: 540px;
  bottom: 0;
  user-select: none;
}
</style>